export enum FunctionType {
  COUNT = 'count',
  SIMPLE_JOIN = 'simpleJoin',
  NORMALIZE = 'normalize',
  NORMALIZE_JOIN = 'normalizeJoin'
}
